import React from "react";
import ContentGuard from "../components/ContentGuard";
import ComingSoon from "./ComingSoon";

const AnalyticsPage = () => {
  return (
    <ContentGuard
      hasContent={false}
      fallbackMessage="Analytics dashboard features are coming soon!"
    >
      <div>{/* Analytics content will go here */}</div>
    </ContentGuard>
  );
};

export default AnalyticsPage;
